import React, {useState} from 'react';
import {SynthesisRequests} from "../../../api/requests/SynthesisRequests"
import {ProjectJson} from "../../../api/json/ProjectJson"
import {useToasts} from "../../../hooks/useToasts"
import {Box, SxProps} from "@mui/material"
import {useIntegrations} from "../../../hooks/useIntegrations"
import AsyncButton from "../../button/AsyncButton"
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import SynthesisResultJson from "../../../api/json/SynthesisResultJson"
import {AnyTemplateJson} from "../../../api/json/TemplateJson"

interface GenerateButtonProps {
    project: ProjectJson
    template: AnyTemplateJson
    disabled?: boolean
    handleResult: (result: SynthesisResultJson) => void
    sx?: SxProps
}

function SynthesizeButton({project, template, disabled, handleResult, sx}: GenerateButtonProps) {
    const [generateInProgress, setGenerateInProgress] = useState(false)

    const toasts = useToasts()
    const {openAi} = useIntegrations()

    const singleSynthesisSettings = {
        templateId: template.id!,
        numberOfRows: 1,
        batchSize: 1,
        alignmentText: "",
        chatModel: "gpt-3.5-turbo",
        validationRatio: 0,
    }

    const generateRow = () => {
        setGenerateInProgress(true)
        SynthesisRequests.synthesize(project.id, singleSynthesisSettings)
            .then((results) => {
                const result = results[0]
                handleResult(result)
            })
            .catch(toasts.showError)
            .finally(() => setGenerateInProgress(false))
    }

    if (!openAi) return <></>

    return (
        <Box sx={sx}>
            <AsyncButton waiting={generateInProgress} onClick={generateRow}
                         disabled={disabled}
                         variant="outlined"
                         color="secondary"
                         size="small"
                         endIcon={<PlaylistAddOutlinedIcon/>}
            >
                Synthesize
            </AsyncButton>
        </Box>
    );
}

export default SynthesizeButton;
